/**
 * Manage the Schools (Nearby schools) display
 */
define(['jquery', 'c21/track'], function ($, track) {
   "use strict";

   var m_jSchools, m_bVisible, m_jMoreSchools, m_sMoreSchoolsText,
      m_jShowMoreSchools, m_jShowFewerSchools;
   
   function doToggle() {
      if (m_bVisible) {
         m_jShowMoreSchools.html(m_sMoreSchoolsText);
         m_jMoreSchools.animate({
            opacity : 0
         }, function() {
            $(this).slideUp(function() {
            });
            m_bVisible = false;
         });
      } else {
         m_jShowMoreSchools.hide();
         m_jShowFewerSchools.show();
         m_jMoreSchools.slideDown(function() {
            $(this).animate({
               opacity : 1
            });
            m_bVisible = true;
         });
      }
   }
   
   function initialize() {
      m_jSchools = $('.schoolDataBody tr');
      
      if (m_jSchools.length > 5) {
         m_jMoreSchools = m_jSchools.slice(5);
         m_jMoreSchools.hide();
         m_jMoreSchools.css({
            opacity : 0
         });
         m_jShowMoreSchools = $('.showMoreSchools');
         m_jShowFewerSchools = $('.showFewerSchools');
         m_sMoreSchoolsText = m_jShowMoreSchools.html(); 
         m_jShowMoreSchools.parent().show();
         
         // Show more schools
         m_jShowMoreSchools.click(function() {
            $(this).hide();
            m_jShowFewerSchools.show();
        	
           	// GA Tracking
            var sourcePage = "";
            if($('#TRACKING_PROPERTY_ID').val() !== null && $('#TRACKING_PROPERTY_ID').val() !== "") {
            	sourcePage = "PDP Hybrid Page";
            } else {
            	sourcePage = "Local Area Page";
            }            
            track.doEvent('Schools', sourcePage, 'Show all onboard schools');
            doToggle();
            return false;
         });
         
         // Show fewer schools
         m_jShowFewerSchools.click(function() {        	 
         	$(this).hide();
           	m_jShowMoreSchools.show();

           	// GA Tracking
             var sourcePage = "";
             if($('#TRACKING_PROPERTY_ID').val() !== null && $('#TRACKING_PROPERTY_ID').val() !== "") {
             	sourcePage = "PDP Hybrid Page";
             } else {
             	sourcePage = "Local Area Page";
             }            
             track.doEvent('Schools', sourcePage, 'Show fewer onboard schools');
             doToggle();
             return false;
          });
      } else {
         $("#showMoreSchoolsContainer").hide();
      }
   }
   
   return {
      initialize : initialize
   };
});